import formatInputMoney from "@/app/infrastructures/misc/common-library/FormatInputMoney";

export const formatNumberOnlyWithZero = (val: any, allowLeadingZero = true) => {
  if (val === null || val === undefined) return "";

  const numericValue = String(val).replace(/\D+/g, "");

  if (!allowLeadingZero) {
    const withoutLeadingZero = numericValue.replace(/^0+/, "");

    return formatInputMoney(withoutLeadingZero);
  }

  return numericValue;
};